import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { FlickrActionTypes } from './types'
import { fetchError, fetchSuccess } from './actions'
import { callApi, flickrAPI } from '../../utils/callApi'

const API_ENDPOINT = 'https://api.flickr.com/services/feeds/photos_public.gne?%1%nojsoncallback=1'

function* handleFetch(search: string) {
  console.log('search', search)
  // let search = '72157627491430747'
  try {
    // To call async functions, use redux-saga's `call()`.
    const res = yield call(
      flickrAPI,
      'GET',
      API_ENDPOINT.replace('%1%', 'tags=' + search + '&format=json&'),
      { tags: search, format: 'json' }
    )

    if (res.error) {
      yield put(fetchError(res.error))
    } else {
      yield put(fetchSuccess(res))
    }
  } catch (err) {
    if (err instanceof Error) {
      yield put(fetchError(err.stack!))
    } else {
      yield put(fetchError('An unknown error occured.'))
    }
  }
}

// This is our watcher function. We use `take*()` functions to watch Redux for a specific action
// type, and run our saga, for example the `handleFetch()` saga above.
function* watchFetchRequest() {
  // console.log('Arguments', arguments)
  yield takeEvery(FlickrActionTypes.FETCH_REQUEST, handleFetch, arguments.payload)
}

// We can also use `fork()` here to split our saga into multiple watchers.
function* flickrSaga() {
  yield all([fork(watchFetchRequest)])
}

export default flickrSaga
